import { useNavigate } from "react-router-dom";
import TableCell from "../../common/table/tableCell";
import { updateEventId } from "../../../redux/reducer/LoginReducer";
import { useAppDispatch } from "../../../redux";

const Row = (props: any) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleRedirect = () => {
    dispatch(updateEventId(props.report._id));
    navigate(`/surveys/farmacia/report`, {
      state: {
        name: props.report.name,
        region: props.report.regionalCode,
      },
    });
  };

  return (
    <tr className="tablePharmacies" onClick={() => handleRedirect()}>
      <TableCell label={props.report.name} class="column-width" />
      <TableCell label={props.report.city} />
      <TableCell label={props.report.regionalCode} />
      <TableCell label={props.report.citizens} />
      <TableCell label={props.report.surveyAnswers} />
    </tr>
  );
};

export default Row;
